module.exports = __webpack_public_path__ + "static/pie_painter_6-2ad43cd102436c4c0ad1355ddef6cd23.png";